var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab-overlay",attrs:{"role":"dialog","aria-modal":"true","aria-label":`Test dashboard${_vm.machineName ? ' for ' + _vm.machineName : ''}`}},[_c('lab-telemetry-viewer',{attrs:{"run-id":_vm.runId,"run":_vm.run,"machine-name":_vm.machineName,"playback":_vm.playback},on:{"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }